module.exports = __webpack_public_path__ + "assets/img/img_2_9_6.1393bb1d.png";